// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__3t9gw","buttonContent":"Button_buttonContent__2ylHp","icon":"Button_icon__AsQS0","spinner":"Button_spinner__24J41"};